
export interface CertificateRawData {
    /**
     * Certificate raw data - this certificate is zip archive
     */
    rawData: Buffer;
}